<script>

    export default {
        props: ['analiseProp', 'tipo'],
        data() {
            return {
                isOpen: true,
                analise: {}
            }
        },
        watch: {
            analiseProp() {
                this.$set(this, 'analise', this.analiseProp)
            },

            analise() {
                if (typeof this.analise.id !== 'undefined') {
                    this.$set(this, 'isOpen', true)
                }
            }
        },
        computed: {
            'montaTipoSolo'() {
                let tipo = '';
                tipo = (this.analise.solo_quimica ? 'Q + ' : '') + (this.analise.solo_fisica ? 'F + ' : '') + (this.analise.solo_extrato_saturacao ? 'EX + ' : '');
                let tamanho = tipo.length-3;
                return tipo.substring(0, tamanho);
            },

            'montaTipoSemente'() {
                let tipo = '';
                tipo = (this.analise.semente_germinacao ? 'Ger + ' : '') + (this.analise.semente_vigor ? 'Vig + ' : '');
                let tamanho = tipo.length-3;
                return tipo.substring(0, tamanho);
            }
        },
        methods: {
            closeModal() {
                this.$set(this, 'isOpen', false)
                this.$emit('close')
            },

            downloadArquivoLog(log, nome) {
                this.$http.post("api/analises-log/download-arquivo/" + log.id).then(response => {
                    if (response.data.arquivo == null) {
                        return window.swal(
                            "Atenção",
                            "Houve um problema ao realizar download.<br><br>" +
                            response.data.mensagem,
                            "warning"
                        );
                    }
                    let a = document.createElement("a");
                    a.href = "data:application/octet-stream;base64," + response.data.arquivo;
                    a.download = nome + '.' + log.arquivo_extensao;
                    a.click();
                });
            }
        },
        mounted() {
            this.$set(this, 'analise', this.analiseProp)
        }
    }
</script>

<template>
    <td v-if="tipo != 'LOG'" colspan="8">
        <table border="1" width="100%" class="table table-striped table-bordered table-hover">
            <tbody v-if="analise.solo != null">
            <tr>
                <th width="10%" class="text-center">Registro</th>
                <th width="8%" class="text-center">Área HA</th>
                <th width="24%">Cidade - UF</th>
                <th width="15%">Localidade</th>
                <th width="15%">Matrícula</th>
                <th width="10%">Lote Rural</th>
                <th width="10%">Ref. Cliente</th>
                <th width="8%" class="text-center">Tipo</th>
            </tr>
            <tr>
                <td class="text-center">{{ analise.data_registro_formatada }}</td>
                <td class="text-center">{{ analise.solo.area_ha }}</td>
                <td>{{ analise.cidade.nome}} - {{ analise.cidade.estado.uf }}</td>
                <td>{{ analise.solo.localidade }}</td>
                <td>{{ analise.solo.matricula }}</td>
                <td>{{ analise.solo.lote_rural }}</td>
                <td>{{ analise.solo.referencia_cliente }}</td>
                <td class="text-center">{{ montaTipoSolo }}</td>
            </tr>
            </tbody>

            <tbody v-if="analise.semente != null">
            <tr>
                <th width="10%" class="text-center">Registro</th>
                <th width="29%">Cidade - UF</th>
                <th width="17%">Amostra</th>
                <th width="17%">Lote</th>
                <th width="17%">Safra</th>
                <th width="10%" class="text-center">Tipo</th>
            </tr>
            <tr>
                <td class="text-center">{{ analise.data_registro_formatada }}</td>
                <td>{{ analise.cidade.nome }} - {{ analise.cidade.estado.uf }}</td>
                <td>{{ analise.semente.amostra }}</td>
                <td>{{ analise.semente.lote }}</td>
                <td>{{ analise.semente.safra }}</td>
                <td class="text-center">{{ montaTipoSemente }}</td>
            </tr>
            </tbody>

            <tbody v-if="analise.tecido != null">
            <tr>
                <th width="10%" class="text-center">Registro</th>
                <th width="30%">Cidade - UF</th>
                <th width="30%">Cultura</th>
                <th width="30%">Referência</th>
            </tr>
            <tr>
                <td class="text-center">{{ analise.data_registro_formatada }}</td>
                <td>{{ analise.cidade.nome }} - {{ analise.cidade.estado.uf }}</td>
                <td>{{ analise.cultura.nome }}</td>
                <td>{{ analise.tecido.referencia }}</td>
            </tr>
            </tbody>

            <tbody v-if="analise.fertilizante != null">
            <tr>
                <th width="10%" class="text-center">Registro</th>
                <th width="30%">Cidade - UF</th>
                <th width="20%" class="text-center">Nitrogênio (%)</th>
                <th width="20%" class="text-center">Fósforo (%)</th>
                <th width="20%" class="text-center">Potássio (%)</th>
            </tr>
            <tr>
                <td class="text-center">{{ analise.data_registro_formatada }}</td>
                <td>{{ analise.cidade.nome }} - {{ analise.cidade.estado.uf }}</td>
                <td class="text-center">{{ analise.fertilizante.nitrogenio }}</td>
                <td class="text-center">{{ analise.fertilizante.fosforo }}</td>
                <td class="text-center">{{ analise.fertilizante.potassio }}</td>
            </tr>
            </tbody>
        </table>
    </td>

    <td v-else colspan="8">
        <table border="1" width="100%" class="table table-striped table-bordered table-hover">
            <tbody>
            <tr>
                <th width="5%" class="text-center">Data / hora</th>
                <th width="5%" class="text-center">Solicitante</th>
                <th width="10%" class="text-center">Registro</th>
                <th width="40%" class="text-center">Alterações</th>
                <th width="30%" class="text-center">Observações</th>
                <th width="5%" class="text-center">Arquivo</th>
            </tr>
            <tr v-for="(log, index) in analise.logs_analise">
                <td class="text-center">{{log.created_at}}</td>
                <td class="text-center">{{log.solicitante}}</td>
                <td class="text-center">{{ analise.registro }} / {{ analise.ano_registro }}.{{ index + 2 }}</td>
                <td class="text-left">
                    <pre class="nl2br">{{log.texto_alteracoes}}</pre>
                </td>
                <td class="text-left">
                    <pre class="nl2br">{{log.observacoes}}</pre>
                </td>
                <td class="text-center">
                    <button class="btn btn-xs btn-info"
                            :disabled="log.caminho_arquivo == null"
                            @click="downloadArquivoLog(log, analise.registro +' / '+ analise.ano_registro +'.'+ index + 2 )"
                            title="Download arquivo"><i class="fa fa-download"></i>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
    </td>
</template>
<style>
    .nl2br {
        font-family: "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
        background: none;
        overflow: hidden;
        padding: 0px;
        margin: 0px;
        border: 0px;
        border-radius: 0px;
    }
</style>